import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const PACKAGE_SELECTION_API = ShipbobAppSettings.AppSettings.PackageSelectionBaseUrl

class PackageSelectionServiceInternal {
  urls () {
    return {
      calculatePackageSize: PACKAGE_SELECTION_API + '/api/packageCalc/GetBestPackages'
    }
  }

  handleGetBestPackagesError = (res) => {
    toastr['error']('Unable to retrieve package size')
  }

  async calculatePackageSize (data) {
    const request = {
      Url: this.urls().calculatePackageSize,
      Data: data
    }

    const response = await HttpWrapper.Post(request, undefined, this.handleGetBestPackagesError, true)
    return response
  }
}

export const PackageSelectionService = new PackageSelectionServiceInternal()
